import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import type {
  KnowledgeArticleListDto,
  KnowledgeArticleListDtoListResponse,
} from '#pie/internal/api/pie-bff';
import { Card } from '../card/Card';
import { SkeletonLines } from '../skeleton-lines/SkeletonLines';
import { Stack } from '../stack/Stack';
import { StatusTag } from '../status-tag/StatusTag';
import { Text } from '../text/Text';

interface KnowledgeRecentProps {
  data: KnowledgeArticleListDtoListResponse | undefined;
  isLoading: boolean;
}

export const KnowledgeRecent = ({ data, isLoading }: KnowledgeRecentProps) => {
  const { t } = useTranslation();

  return (
    <section className="my-6">
      <Text variant="h4" className="mb-6">
        {t('knowledge_base.recent.title')}
      </Text>
      <Stack gap="md" className="grid grid-cols-2 gap-6 lg:grid-cols-3 ">
        {isLoading
          ? Array.from({ length: 3 }).map((_, i) => (
              <SkeletonLines lines={3} key={i} />
            ))
          : data?.items?.slice(0, 3).map((article: KnowledgeArticleListDto) => (
              <Link to={`/kennisbank/${article.id}`} key={article.id}>
                <Card
                  key={article.id}
                  size="md"
                  className="flex flex-col h-full"
                  variant="interactive"
                >
                  <Stack
                    className="border-b border-border-minimal-enabled pb-3 flex-grow"
                    gap="sm"
                  >
                    <Text as="h2" variant="h5" className="flex-grow">
                      {article.title}
                    </Text>
                    <Text className="mt-auto">{article.description}</Text>
                  </Stack>
                  <Stack direction="row" className="justify-between mt-2">
                    <Text className="text-content-tertiary" variant="xs">
                      {format(new Date(article.modifiedOn), 'dd MMMM yyyy')}
                    </Text>
                    <Text>
                      <StatusTag status={'closed'}>
                        {article.mainCategory.label}
                      </StatusTag>
                    </Text>
                  </Stack>
                </Card>
              </Link>
            ))}
      </Stack>
    </section>
  );
};
